import { menuselect_solution } from "@/constant/menuselect";

let str = "产品概述";
export const config = {
  title: "医共体管理",
  headerInfo:
    "敬在医共体运营管理旨在消除信息孤岛，实现院内外、院间资源、信息高速共享。 系统通过统一的财务管控及成本管理、统一人力及绩效管理、统一采购及物资管理、运营分析等核心功能，达到成员机构自身业务、财务数据横向一体化，实现资金流、信息流、物流合一。在医共体的管理框架内，保障成员机构数据的完整性、准确性和追溯性。",
  headerImg: require("@/assets/images/medical_community_management/Rectangle19header.svg"),
  activeSubTitle: str,
  navList: [
    {
      name: "医疗集团管理",
      children: menuselect_solution(),
    },
    {
      name: "产品概述",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: "敬在医共体运营管理旨在消除信息孤岛，实现院内外、院间资源、信息高速共享。 系统通过统一的财务管控及成本管理、统一人力及绩效管理、统一采购及物资管理、运营分析等核心功能，达到成员机构自身业务、财务数据横向一体化，实现资金流、信息流、物流合一。在医共体的管理框架内，保障成员机构数据的完整性、准确性和追溯性。",
          img: require("@/assets/images/medical_community_management/Frame 933one.svg"),
        },
       /*  {
          title: "建设方案",
          desc: "建设责任共同体、管理共同体、服务共同体、利益共同体，四维一体紧密型医疗共同体。重点建设资源端基于HRP管理的高效运营平台，实现运营管理的闭环；对营收端进行梳理、规范和逐步整合；丰富解决方案，助力医共体运营管理及发展战略落地，既能全面实现医共体、集团化医院共享整合目标，又能满足单独医疗机构的运营管理需求",
          img: require("@/assets/images/medical_community_management/Group 933one.svg"),
        },
        {
          title: "应用价值：一体管控、资源共享",
          desc: "消除信息孤岛、实现院内、院间信息资源快速高效共享。通过多组织架构的运营管理功能模块，实现多个医疗单位人事、物资、成本、绩效、财务核算的统一运营管理。",
          img: require("@/assets/images/medical_community_management/Frame 935one.svg"),
        }, */
      ],
    },
    {
      name: "建设方案",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          title: "建设方案",
          desc: "建设责任共同体、管理共同体、服务共同体、利益共同体，四维一体紧密型医疗共同体。重点建设资源端基于HRP管理的高效运营平台，实现运营管理的闭环；对营收端进行梳理、规范和逐步整合；丰富解决方案，助力医共体运营管理及发展战略落地，既能全面实现医共体、集团化医院共享整合目标，又能满足单独医疗机构的运营管理需求",
          img: require("@/assets/images/medical_community_management/Group 933one.svg"),
        },
      ],
    },
    {
      name: "应用价值",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          title: "应用价值：一体管控、资源共享",
          desc: "消除信息孤岛、实现院内、院间信息资源快速高效共享。通过多组织架构的运营管理功能模块，实现多个医疗单位人事、物资、成本、绩效、财务核算的统一运营管理。",
          img: require("@/assets/images/medical_community_management/Frame 935one.svg"),
        },
      ],
    },
  ],
};
